import { forwardRef } from "react";
import { cn } from "@/lib/style/cva.config";

export const FormFieldContainer = forwardRef<HTMLDivElement, React.ComponentProps<"div">>(
  function FormFieldContainer(props, ref) {
    return (
      <div
        ref={ref}
        {...props}
        className={cn("flex flex-col gap-2 font-medium text-txt-primary", props.className)}
      />
    );
  },
);
